export default __webpack_public_path__ + "static/media/1610.f8cfabf2.png";